module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I hate it! Please God, I hate it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having said this, he was at peace with all he had told me this night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He turned his head toward the wall, as if to feel a morning’s warmth at the unseen window.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was well past midnight, into black Sunday, but the time of day had no meaning for him. A smile played carefully across his face as he lay in his bed, a bed too big for him alone. I put my hand on his. He let it lie there atop his paper skin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I asked, “What is it you hate?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He drew a deep breath and his blind blue eyes closed. Then he quoted again, from what his mind still pictured of pages he used to read, time and again: “Out of Ireland have we come; great hatred, little room, maimed at the start … I carry from my mother’s womb a fanatic heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was silence where I should have offered reaction, the kind of embarrassed quietude that tells an old man he has not been understood by a younger man. His useless eyes fluttered open and he said, with some exasperation, “It’s the root of this madness I’ve grown to hate, it’s old men at their windows I hate even "), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v(" more.” Then he lifted my hand away and said, “Now get you off.” That would be all for now, whether or not I understood. He needed rest.")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I walked to the door and opened it, but turned to look at him once more before leaving. He sensed this. His head rose slightly over the mound of blankets. He said, “When I’m gone, I want you to remember me.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("I said, “Haven’t I always?” ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28a1dec0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Fm5.vue
// module id = 78
// module chunks = 0